import { createContext, useContext, useState, ReactNode } from 'react';
import BackupModal from '@/components/feature/BackupModal';

interface BackupModalContextValue {
  openBackup: () => void;
}

const BackupModalContext = createContext<BackupModalContextValue>({
  openBackup: () => {},
});

export function useBackupModal(): BackupModalContextValue {
  return useContext(BackupModalContext);
}

export function BackupModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <BackupModalContext.Provider value={{ openBackup: () => setIsOpen(true) }}>
      {children}
      <BackupModal open={isOpen} onClose={() => setIsOpen(false)} />
    </BackupModalContext.Provider>
  );
}